import { DateTime, Info } from "luxon";
const timezone = process.env.REACT_APP_TIMEZONE || "UTC";
export const getToday = () => DateTime.now().setZone(timezone).startOf("day");
const splitPartialDate = (partialDate) => partialDate.split("-").map((x) => parseInt(x));
const parsePartialDate = (partialDate) => {
    const [year, month, day] = splitPartialDate(partialDate);
    return DateTime.fromObject({
        year,
        month: month || 1,
        day: day || 1,
    }, { zone: timezone }).startOf("day");
};
export const isBirthday = (dateOfBirth) => {
    const [, month, day] = splitPartialDate(dateOfBirth);
    if (month === undefined || day === undefined)
        return false;
    const today = getToday();
    return today.month === month && today.day === day;
};
export const calculateAge = (dateOfBirth) => {
    const accurate = splitPartialDate(dateOfBirth).length === 3;
    const { years, months, days } = getToday()
        .diff(parsePartialDate(dateOfBirth), ["years", "months", "days"])
        .toObject();
    if (years)
        return `${accurate ? "" : "~"}${years} year${years === 1 ? "" : "s"}`;
    if (months)
        return `${accurate ? "" : "~"}${months} month${months === 1 ? "" : "s"}`;
    const floorDays = Math.floor(days !== null && days !== void 0 ? days : 0);
    return `${accurate ? "" : "~"}${floorDays} day${floorDays === 1 ? "" : "s"}`;
};
const getMonthName = (month) => {
    if (month < 1 || month > 12)
        throw new Error("Invalid month");
    return Info.months("long", { locale: "en-US" })[month - 1];
};
const getOrdinal = (number) => {
    if (number < 1)
        throw new Error("Invalid number");
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13)
        return "th";
    if (lastDigit === 1)
        return "st";
    if (lastDigit === 2)
        return "nd";
    if (lastDigit === 3)
        return "rd";
    return "th";
};
export const formatDate = (date, showApproximate = true) => {
    const [year, month, day] = splitPartialDate(date);
    const formattedMonth = month && getMonthName(month);
    const formattedDay = day && `${day}${getOrdinal(day)}`;
    if (day && month && year)
        return `${formattedMonth} ${formattedDay}, ${year}`;
    if (month && year)
        return `${showApproximate ? "~" : ""}${formattedMonth}, ${year}`;
    return `${showApproximate ? "~" : ""}${year}`;
};
export const sortPartialDates = (a, b) => {
    const parsedA = typeof a === "string" ? parsePartialDate(a).toMillis() : null;
    const parsedB = typeof b === "string" ? parsePartialDate(b).toMillis() : null;
    if (parsedA === parsedB)
        return 0;
    else if (parsedA === null || (parsedB !== null && parsedB > parsedA))
        return 1;
    else
        return -1;
};
